module.exports = __webpack_public_path__ + "static/media/9DESA33.9fd804bf.jpg";